import type { FeedItem } from "@knocklabs/client";
import type { NotificationListItem } from "@/client";

export type MergedNotificationEntry =
	| { kind: "legacy"; date: string; item: NotificationListItem }
	| { kind: "knock"; date: string; item: FeedItem };

/** Merges the legacy notifications table and Knock's feed into one
 * chronological list - the two now render in a single panel behind one
 * bell icon, but stay two distinct data sources with no overlapping
 * event types, so this only interleaves by date rather than deduping. */
export function mergeNotificationEntries(
	legacyItems: NotificationListItem[],
	knockItems: FeedItem[],
): MergedNotificationEntry[] {
	const entries: MergedNotificationEntry[] = [
		...legacyItems.map(
			(item): MergedNotificationEntry => ({
				kind: "legacy",
				date: item.created_at ?? "",
				item,
			}),
		),
		...knockItems.map(
			(item): MergedNotificationEntry => ({
				kind: "knock",
				date: item.inserted_at,
				item,
			}),
		),
	];

	return entries.sort(
		(a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
	);
}

export function groupMergedEntriesByDay(
	entries: MergedNotificationEntry[],
): Record<string, MergedNotificationEntry[]> {
	return entries.reduce(
		(acc, entry) => {
			const day = entry.date.split("T")[0];
			if (!acc[day]) {
				acc[day] = [];
			}
			acc[day].push(entry);
			return acc;
		},
		{} as Record<string, MergedNotificationEntry[]>,
	);
}
